<script lang="ts" setup>
import { faPlus } from "@fortawesome/pro-regular-svg-icons";
import type { Account } from "~/models/User";

const props = withDefaults(
    defineProps<{
        open: boolean;
        accounts: Account[];
        user: any;
        roles: { label: string; value: string }[];
        currentAccountId: number;
        currentRole: string;
        createAccountModal: () => void;
        switchAccountModal: () => void;
        updateAccount: () => void;
    }>(),
    {},
);

const emit = defineEmits<{
    (e: "update:open", v: boolean): void;
    (e: "invite"): void;
    (e: "switch-account", account_id: number): void;
}>();

const isOpen = computed({
    get: () => props.open,
    set: (v) => emit("update:open", v),
});

const userData = computed(() => props.user);
</script>

<template>
    <UModal v-model="isOpen">
        <UCard
            :ui="{
                ring: '',
                divide: 'divide-y divide-gray-100 dark:divide-gray-800',
            }"
        >
            <template #header>
                <div class="flex items-center justify-between">
                    <div class="flex items-center justify-between gap-4">
                        <h3
                            class="text-base font-semibold leading-6 text-gray-900 dark:text-white"
                        >
                            Your Account
                        </h3>
                        <UButton
                            color="hd-primary"
                            size="sm"
                            class="px-4 py-2 focus-visible:ring-0"
                            @click="
                                () => {
                                    createAccountModal();
                                    switchAccountModal();
                                }
                            "
                        >
                            <template #leading>
                                <FontAwesomeIcon :icon="faPlus" size="lg" />
                            </template>
                            <span>New Account</span>
                        </UButton>
                    </div>
                    <UButton
                        color="gray"
                        variant="ghost"
                        autofocus="off"
                        icon="i-heroicons-x-mark-20-solid"
                        class="-my-1"
                        @click="props.switchAccountModal"
                    />
                </div>
            </template>

            <div class="flex flex-col gap-4">
                <UFormGroup label="Account" size="lg">
                    <USelectMenu
                        v-model="user.account_id"
                        :options="props.accounts"
                        value-attribute="id"
                        option-attribute="name"
                        searchable
                    />
                </UFormGroup>
                <UFormGroup label="Role" size="lg">
                    <UISelectMenu
                        size="lg"
                        :options="roles"
                        value-attribute="value"
                        v-model="user.role"
                    />
                </UFormGroup>
            </div>

            <template #footer>
                <UButton
                    color="primary"
                    :disabled="
                        props.currentAccountId === userData.account_id &&
                        props.currentRole === user.role
                    "
                    @click="updateAccount"
                    >Switch Now</UButton
                >
            </template>
        </UCard>
    </UModal>
</template>
